import React from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import isEqual from 'lodash.isequal';
import isEmpty from 'lodash.isempty';

import {searchActivities, setSearchValue} from "../../actions/findActivities/search/get";

class Select extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            options: this.props.options,
            filter_group_id: this.props.filter_group_id,
            visibleStr : 'Select One...',
            radius : this.props.value || '',
        };

        this.update = this.update.bind(this);
    }
    
    componentWillMount() {
        if (this.props.selectedFilters[this.props.filter_group_id] && this.props.name !== 'radius') {
            const intSelectedFilterId = this.props.selectedFilters[this.props.filter_group_id][0];
            if (typeof intSelectedFilterId !== 'undefined' && this.props.options.length !== 0) {
                this.props.options.map((o) => {
                    if (this.props.filter_group_id.toString() === o.filter_id.toString() && intSelectedFilterId.toString() === o.id.toString()) {
                        this.setState({
                            visibleStr :this.titleCase(o.value)
                        })
                    }
                });
            }
        }

        if (this.props.name === 'radius') {
            this.props.options.map((o) => {
                if (this.props.value.toString() === o.id.toString()) {
                    this.setState({
                        visibleStr :this.titleCase(o.value)
                    });
                }
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!isEqual(this.props.selectedFilters, nextProps.selectedFilters) && isEmpty(nextProps.selectedFilters)) {
            this.selectRef.value = -1;
        }
    }

    update (e) {

        this.props.onChange(e);

        if (e.target.value === '') {
            this.setState({
                visibleStr :'Select One...',
            })
        }
        if (e.target.value) {

            if (e.target.name !== 'radius') {
                const intSelectedFilterId = this.props.selectedFilters[this.props.filter_group_id][0];

                if (typeof intSelectedFilterId !== 'undefined' && this.props.options.length !== 0) {
                    this.props.options.map((o) => {

                        if (this.props.filter_group_id.toString() === o.filter_id.toString() && intSelectedFilterId.toString() === o.id.toString()) {
                            this.setState({
                                visibleStr :this.titleCase(o.value)
                            })
                        }
                    });
                }
            }

            if (e.target.name === 'radius') {
                this.setState({
                    radius : e.target.value,
                });

                this.props.options.map((o) => {
                    if (e.target.value.toString() === o.id.toString()) {
                        this.setState({
                            visibleStr :this.titleCase(o.value)
                        })
                    }
                });
            }
        }

        this.props.searchActivities(this.props.searchValues, this.props.selectedFilters);
    }

    titleCase = str => str.toLowerCase().split(' ').map(word => (word.charAt(0).toUpperCase() + word.slice(1))).join(' ');

    render() {

        const { name, id, value, options, editable } = this.props;

        let niceselectText = '';

        if (name !== 'radius') {
            niceselectText = Object.keys(this.props.selectedFilters).length === 0 ? 'Select One...' : this.state.visibleStr;
        }

        if (name === 'radius') {
            niceselectText = (this.state.radius === '') ? 'Select One...' : this.state.visibleStr;
        }

        return (
            <div className={value ? 'niceselect-wrapper' : 'niceselect-wrapper niceselect-default'}>
                <span className="niceselect-text">{ niceselectText }</span>
                <select onChange={this.update} name={name} id={id} className="js-nice-select" ref={(selectRef) => { this.selectRef = selectRef; }}>
                    <option value="">Please Select</option>
                    {options.length === 0 ? <option value="">Loading...</option> : null}
                    {options.map(o => (
                        <option value={editable ? o.id : o.key} key={o.id}>
                            {this.titleCase(o.value)}
                        </option>
                    ))}
                </select>
            </div>
        );
    }
}

Select.propTypes = {
  placeholder: PropTypes.string,
  options: PropTypes.array,
  editable: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

Select.defaultProps = {
  placeholder: '',
  options: [],
  editable: 1,
};

const mapStateToProps = (state) => ({
    selectedFilters : state.selectedFilters,
    searchValues: state.searchValues,
});
const mapDispatchToProps = dispatch => ({
    searchActivities: (values, filters) => {
        dispatch(searchActivities(values, filters));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(Select);

